import {
  HttpEvent,
  HttpEventCallbacks,
  httpDelete,
  httpGet,
  httpPost,
  httpPut,
} from "@/events/eventsDomain";

export type AccountRoleType = {
  id: string;
  name: string;
};

export const accountRoleSystemAccesses = ["NONE", "BOARD_PORTAL"] as const;

export type AccountRoleSystemAccess = (typeof accountRoleSystemAccesses)[number];

export const accountRoleActivations = ["ALL_COMPANIES", "SELECTED_COMPANIES", "HIDDEN"] as const;

export type AccountRoleActivation = (typeof accountRoleActivations)[number];

export type AccountRoleTypeItem = AccountRoleType & {
  description?: string;
  systemAccess: AccountRoleSystemAccess;
  activation: AccountRoleActivation;
  selectedCompanyIds: string[];
  holderCount: number;
};

export type AccountRoleTypeRequest = {
  name: string;
  description?: string;
  systemAccess: AccountRoleSystemAccess;
  activation: AccountRoleActivation;
  selectedCompanyIds: string[];
};

export type AccountRoleTypeApiClient = {
  list: (
    accountId: string,
    params: HttpEventCallbacks<AccountRoleTypeItem[]>,
  ) => HttpEvent<AccountRoleTypeItem[]>;
  add: (
    accountId: string,
    request: AccountRoleTypeRequest,
    params: HttpEventCallbacks<AccountRoleTypeItem[]>,
  ) => HttpEvent<AccountRoleTypeItem[]>;
  update: (
    accountId: string,
    roleTypeId: string,
    request: AccountRoleTypeRequest,
    params: HttpEventCallbacks<AccountRoleTypeItem[]>,
  ) => HttpEvent<AccountRoleTypeItem[]>;
  delete: (
    accountId: string,
    roleTypeId: string,
    params: HttpEventCallbacks<AccountRoleTypeItem[]>,
  ) => HttpEvent<AccountRoleTypeItem[]>;
};

const roleTypesUrl = (accountId: string) =>
  `/enterprise-accounts/${encodeURIComponent(accountId)}/role-types`;

const roleTypeUrl = (accountId: string, roleTypeId: string) =>
  `${roleTypesUrl(accountId)}/${encodeURIComponent(roleTypeId)}`;

export const accountRoleTypeApiClient: AccountRoleTypeApiClient = {
  list: (accountId, params) => httpGet({ url: roleTypesUrl(accountId), ...params }),
  add: (accountId, request, params) =>
    httpPost({ url: roleTypesUrl(accountId), data: request, ...params }),
  update: (accountId, roleTypeId, request, params) =>
    httpPut({ url: roleTypeUrl(accountId, roleTypeId), data: request, ...params }),
  delete: (accountId, roleTypeId, params) =>
    httpDelete({ url: roleTypeUrl(accountId, roleTypeId), ...params }),
};
